"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("page", {
    staticClass: "structure-page",
    attrs: {
      menu: _vm.menuItems.children,
      "sub-menu": _vm.menuItems.subMenu,
      "return-menu": "/farm-management/dashboard"
    }
  }, [_c("template", {
    slot: "context"
  }, [_c("div", {
    staticClass: "header"
  }, [_c("h2", {
    staticClass: "header-title"
  }, [_vm._v("\n        Estrutura\n      ")]), _vm._v(" "), _c("div", {
    staticClass: "search-bar"
  }, [_c("div", {
    staticClass: "field-new-item"
  }, [_c("b-button", {
    on: {
      click: function click($event) {
        return _vm.openLoteModal();
      }
    }
  }, [_vm._v("\n            Novo Lote\n          ")])], 1)])]), _vm._v(" "), _c("div", {
    staticClass: "content-wrapper"
  }, [_c("div", {
    staticClass: "lotes-container"
  }, _vm._l(_vm.lotes, function (lote) {
    return _c("div", {
      key: lote.id,
      staticClass: "lote-item"
    }, [_c("div", {
      staticClass: "lote-header",
      on: {
        click: function click($event) {
          return _vm.toggleLote(lote.id);
        }
      }
    }, [_c("div", {
      staticClass: "lote-info"
    }, [_c("h3", [_vm._v(_vm._s(lote.nome))]), _vm._v(" "), _c("span", {
      staticClass: "lote-size"
    }, [_vm._v(_vm._s(lote.tamanho) + " ha")])]), _vm._v(" "), _c("div", {
      staticClass: "lote-actions",
      on: {
        click: function click($event) {
          $event.stopPropagation();
        }
      }
    }, [_c("b-dropdown", {
      attrs: {
        "aria-role": "list",
        position: "is-bottom-left"
      }
    }, [_c("b-button", {
      staticClass: "action-menu",
      attrs: {
        slot: "trigger",
        "icon-right": "dots-vertical"
      },
      slot: "trigger"
    }), _vm._v(" "), _c("b-dropdown-item", {
      on: {
        click: function click($event) {
          return _vm.editLote(lote);
        }
      }
    }, [_c("b-icon", {
      attrs: {
        icon: "pencil",
        size: "is-small"
      }
    }), _vm._v("\n                  Editar\n                ")], 1), _vm._v(" "), _c("b-dropdown-item", {
      on: {
        click: function click($event) {
          return _vm.deleteLote(lote);
        }
      }
    }, [_c("b-icon", {
      attrs: {
        icon: "delete",
        size: "is-small"
      }
    }), _vm._v("\n                  Excluir\n                ")], 1)], 1), _vm._v(" "), _c("b-icon", {
      staticClass: "expand-icon",
      attrs: {
        icon: _vm.expandedLotes.includes(lote.id) ? "chevron-up" : "chevron-down"
      }
    })], 1)]), _vm._v(" "), _vm.expandedLotes.includes(lote.id) ? _c("div", {
      staticClass: "setores-container"
    }, [_c("div", {
      staticClass: "setores-header"
    }, [_c("h4", [_vm._v("Setores")]), _vm._v(" "), _c("b-button", {
      attrs: {
        size: "is-small"
      },
      on: {
        click: function click($event) {
          return _vm.openSetorModal(lote.id);
        }
      }
    }, [_vm._v("\n                Novo Setor\n              ")])], 1), _vm._v(" "), _vm._l(lote.setores, function (setor) {
      var _vm$selectedSetor;
      return _c("div", {
        key: setor.id,
        staticClass: "setor-item",
        class: {
          selected: ((_vm$selectedSetor = _vm.selectedSetor) === null || _vm$selectedSetor === void 0 ? void 0 : _vm$selectedSetor.id) === setor.id
        },
        on: {
          click: function click($event) {
            return _vm.selectSetor(setor, lote);
          }
        }
      }, [_c("div", {
        staticClass: "setor-info"
      }, [_c("span", {
        staticClass: "setor-name"
      }, [_vm._v(_vm._s(setor.nome))]), _vm._v(" "), _c("span", {
        staticClass: "setor-size"
      }, [_vm._v(_vm._s(setor.tamanho) + " ha")])]), _vm._v(" "), _c("div", {
        staticClass: "setor-actions",
        on: {
          click: function click($event) {
            $event.stopPropagation();
          }
        }
      }, [_c("b-dropdown", {
        attrs: {
          "aria-role": "list",
          position: "is-bottom-left"
        }
      }, [_c("b-button", {
        staticClass: "action-menu",
        attrs: {
          slot: "trigger",
          "icon-right": "dots-vertical",
          size: "is-small"
        },
        slot: "trigger"
      }), _vm._v(" "), _c("b-dropdown-item", {
        on: {
          click: function click($event) {
            return _vm.editSetor(setor, lote.id);
          }
        }
      }, [_c("b-icon", {
        attrs: {
          icon: "pencil",
          size: "is-small"
        }
      }), _vm._v("\n                    Editar\n                  ")], 1), _vm._v(" "), _c("b-dropdown-item", {
        on: {
          click: function click($event) {
            return _vm.deleteSetor(setor, lote.id);
          }
        }
      }, [_c("b-icon", {
        attrs: {
          icon: "delete",
          size: "is-small"
        }
      }), _vm._v("\n                    Excluir\n                  ")], 1)], 1)], 1)]);
    })], 2) : _vm._e()]);
  }), 0), _vm._v(" "), _vm.selectedSetor ? _c("div", {
    staticClass: "applications-container"
  }, [_c("div", {
    staticClass: "applications-header"
  }, [_c("h3", [_vm._v("Aplicações - " + _vm._s(_vm.selectedSetor.nome))]), _vm._v(" "), _c("span", {
    staticClass: "setor-info-text"
  }, [_vm._v(_vm._s(_vm.selectedLote.nome) + " - " + _vm._s(_vm.selectedSetor.tamanho) + " ha")])]), _vm._v(" "), _c("div", {
    staticClass: "table-items-list"
  }, [_c("b-table", {
    attrs: {
      data: _vm.setorApplications,
      loading: _vm.loadingApplications,
      striped: true,
      hoverable: true
    }
  }, [[_c("b-table-column", {
    attrs: {
      field: "status",
      label: "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_c("b-tag", {
          attrs: {
            type: _vm.getStatusType(props.row.status, props.row.dataAplicacao)
          }
        }, [_vm._v("\n                  " + _vm._s(_vm.getStatusLabel(props.row.status, props.row.dataAplicacao)) + "\n                ")])];
      }
    }], null, false, 343110297)
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "dataAplicacao",
      label: "Data da aplicação"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n                " + _vm._s(_vm.formatDate(props.row.dataAplicacao)) + "\n              ")];
      }
    }], null, false, 2216708096)
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "prescricao",
      label: "Prescrição"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n                " + _vm._s(props.row.prescricao) + "\n              ")];
      }
    }], null, false, 2643289916)
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "produtos",
      label: "Produtos"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [props.row.produtos && props.row.produtos.length ? _c("span", [_vm._v("\n                  " + _vm._s(props.row.produtos.join(", ")) + "\n                ")]) : _c("span", [_vm._v("--")])];
      }
    }], null, false, 3736301622)
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "tempoTrabalho",
      label: "Tempo de trabalho"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n                " + _vm._s(props.row.tempoTrabalho || "--") + "\n              ")];
      }
    }], null, false, 1769001329)
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "periodoAplicacao",
      label: "Período de aplicação"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n                " + _vm._s(props.row.periodoAplicacao || "--") + "\n              ")];
      }
    }], null, false, 1069638380)
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "aplicador",
      label: "Aplicador"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n                " + _vm._s(props.row.aplicador || "--") + "\n              ")];
      }
    }], null, false, 3800757938)
  })], _vm._v(" "), _c("template", {
    slot: "empty"
  }, [_c("section", {
    staticClass: "section"
  }, [_c("div", {
    staticClass: "content has-text-grey has-text-centered"
  }, [_c("p", [_c("b-icon", {
    attrs: {
      icon: "emoticon-sad",
      size: "is-large"
    }
  })], 1), _vm._v(" "), _c("p", [_vm._v("Nenhuma aplicação encontrada para este setor.")])])])])], 2)], 1)]) : _vm._e()])])], 2);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;